var _defs, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrowserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ui",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.04 35.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f9604a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.6,14.83c6.17-4,14.89-.58,17.41,3.88.9,1.59,1.07,7-1.24,10.31-3.32,4.77-10.72,8.87-17.54,5.67C10.65,31.59,12.4,18.82,18.6,14.83Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.1,17.39a5.06,5.06,0,0,1,6.58,1.47,4.71,4.71,0,0,1-.47,3.89C7,24.55,4.15,26.1,1.58,24.89S-.25,18.9,2.1,17.39Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.92,2.88c2.75-.71,4.29,2.86,4.1,5.42-.2,2.73-6.15,4.45-9.34,2.13S28.62,4,32.92,2.88Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.21,3.85c1.84.46,2.47,5.62,1.89,7.63a3.92,3.92,0,0,1-5.66,2.45C3.63,12.56,2.71,9.41,5.18,6.46S8.86,3.51,10.21,3.85Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.81.45C20.55-1.1,23.15,1.64,24,4,25,6.58,21.3,10.1,18,9S16.09,2.89,18.81.45Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserIcon);
export default __webpack_public_path__ + "static/media/browser-icon.05045498cdd1e6dd07375dea5dd354bc.svg";
export { ForwardRef as ReactComponent };